import projectUpload from './projectUpload'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/rem'
import store from './stores/store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import plugin from "./plugins/index"
Vue.use(ElementUI)
Vue.use(plugin,router)


import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


Vue.prototype.$projectUpload = projectUpload
Vue.config.productionTip = false

let search = searchToMap();
if(search.token) localStorage.setItem("token",search.token)
localStorage.setItem("search",JSON.stringify(search));

 //判断url中是否带有token
 let resu = location.href.indexOf('token')
 if (resu > 0) {
   let href = location.href
   href = href.split('?')[0]
   location.href = href
 }

let v = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if ((to.path.indexOf('member')>0||to.path.indexOf('favorites')>0) && !v.$store.state.isLogin){
    next(false)
    v.$store.commit('setShowLogin', true)
  }else{
    next()
  }
})

function searchToMap(){
  let search = location.search.slice(1);
  let map = {};
  if(search){
    let _searchs = search.split('?');
    _searchs.forEach(_s=>{
      let _array =_s.split('&');
      _array.forEach(str => {
        let _str = str.split('=');
        map[_str[0]] = _str[1];
      });
    })
  }
  return map;
}